<div class="p-fluid p-m-3 show-on-print">
  <div class="p-d-flex p-jc-center p-mt-3">
    <div class="preview-container">
      @if (selectedFileName) {
        <app-file-viewer [fileName]="selectedFileName"
        [fileUrl]="selectedFileUrl" [itemId]="itemId"></app-file-viewer>
      }
      @if (itemId) {
        <div class="annotation ">
          <ngx-barcode6 [bc-format]="'code128'" [bc-value]="itemId" [bc-display-value]="true">
          </ngx-barcode6>
        </div>
      }
    </div>
  </div>
</div>